<template>
<div>
  <input
    :placeholder="__('Coupon code')"
    class="input-field"
    v-model="couponCode"
    @change="checkCouponCode"
    />
  <div class="loader-wrapper">
    <line-loader v-if="isPendingCouponCode" />

    <i v-if="invalidCouponCode">
      {{__('Invalid code')}}
    </i>
  </div>
</div>
</template>
<script>

import LineLoader from '@/components/elements/LineLoader.vue'

import { mapGetters } from 'vuex'

export default {
  components: { LineLoader },
  computed: {
    ...mapGetters(['invalidCouponCode', 'isPendingCouponCode']),
    couponCode: {
      get () {
        return this.$store.getters.couponCode
      },
      set (value) {
        this.$store.commit('couponCode', value)
      }
    }
  },
  mounted () {
    this.$nextTick(this.checkCouponCode)
  },
  methods: {
    checkCouponCode () {
      this.$store.dispatch('checkCouponCode')
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  .input-field {
    border-radius: 5px;
    border: none;
    box-sizing: border-box;
    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.2);
    height: 50px;
    padding-left: 20px;
    width: 100%;
    margin-bottom: 10px;
  }

  .loader-wrapper {
    height: 20px;
    width: 100%;

    i {
      color: @warning-dark;
      font-size: 14px;
    }
  }
</style>
